import React from "react";

export default function Close({
  width = "12",
  height = "12",
  color = "#717171",
  className = "",
  onClick = () => {},
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        d="M10.64 8.0005L15.5898 3.05069C16.1367 2.50379 16.1367 1.61712 15.5898 1.07107L14.9299 0.411202C14.3828 -0.135871 13.4962 -0.135871 12.9501 0.411202L8.0005 5.36084L3.05069 0.410177C2.50379 -0.136726 1.61712 -0.136726 1.07107 0.410177L0.410177 1.07005C-0.136726 1.61712 -0.136726 2.50379 0.410177 3.04983L5.36084 8.0005L0.411202 12.9501C-0.135871 13.4972 -0.135871 14.3839 0.411202 14.9299L1.07107 15.5898C1.61798 16.1367 2.50464 16.1367 3.05069 15.5898L8.0005 10.64L12.9501 15.5898C13.4972 16.1367 14.3839 16.1367 14.9299 15.5898L15.5898 14.9299C16.1367 14.3828 16.1367 13.4962 15.5898 12.9501L10.64 8.0005Z"
        fill={color}
      />
    </svg>
  );
}
